module.exports = __webpack_public_path__ + "img/arcos-c-img-6.8072d3d3.jpg";